export interface Environment{
  env: 'PROD'|'SIMULATION'|'QA'|'DEV';
  api_url: string;
  contemporary_url: string;
  spog_url: string;
  isDiffServerForContemporary: boolean;
  leftNavMode: string;
  thirtParty_url: string;
  isspogTransEnabled: boolean;
  apiGatewayHostUrl: string;
  msw_url: string;
  accounts_url: string;
  pendo_api_key: string;
  sp_url: string;
}

export const envCongif: Environment = getConfig();
import * as envConfiguration from '../../src/config.json';

export function detectIE():boolean {
  try {
    const ua = window.navigator.userAgent;
    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      return true;
    }
  } catch (e) {}
  // other browser
  return false;
}

function checkIfLocalHost() {
  return window.location.href.indexOf('localhost') > -1 ? true : false;
}

/**
 * @param env
 * This method returns API URL in localhost
 * pass env === 'DEV': for DEV APIS
 * pass env === 'QA' : for QA  APIS
 * @returns API URL,
 */
function getEnvSpecificUrl(env: string) {
  return process.env[`MSW_${env}_API_URL_LOCAL`];
}

/**
  * change this @property {String} localhostEnv  variable to DEV if you want to point to DEV server in localhost
  * change this @property {String} localhostEnv  variable to QA  if you want to point to QA  server in localhost
  * change this @property {String} localhostEnv  variable to SIMULATION if you want to point to SIMULATION server in localhost
  * change this @property {String} localhostEnv  variable to PROD  if you want to point to PROD  server in localhost
*/
export function getConfig() {
  const localhostEnv = 'DEV';
  const enviormentAPIUrl = getEnvSpecificUrl(localhostEnv);
  const environmentVar: Environment = {
    env: checkIfLocalHost() ? localhostEnv : envConfiguration.default.environment_type,
    api_url:  checkIfLocalHost() ? enviormentAPIUrl : envConfiguration.default.api_url,
    thirtParty_url : checkIfLocalHost() ? getEnvSpecificUrl('THIRDPARTY_DEV_QA') : envConfiguration.default.thirdParty_url,
    contemporary_url:  checkIfLocalHost() ? getEnvSpecificUrl('MSW_URL') : envConfiguration.default.contemporary_url,
    spog_url: checkIfLocalHost() ? getEnvSpecificUrl('SPOG_URL') : envConfiguration.default.Spog_url,
    isDiffServerForContemporary: false,
    leftNavMode : (location.search.includes('mode=APP')) ? 'APP' : 'workflow',
    isspogTransEnabled: true,
    msw_url: checkIfLocalHost() ? getEnvSpecificUrl('MSW_URL') : envConfiguration.default.msw_url,
    apiGatewayHostUrl : checkIfLocalHost() ? enviormentAPIUrl : envConfiguration.default.api_url,
    accounts_url:  envConfiguration.default.accounts_url || '',
    pendo_api_key: envConfiguration.default.pendo_api_key || '',
    sp_url: envConfiguration.default.sp_url || '',
  };
  if (!checkIfLocalHost() && envConfiguration.default.environment_type === 'DEV' || envConfiguration.default.environment_type === 'QA') {
    console.warn('Environment Configuration comment check: ', envConfiguration);
    console.warn('Current uuif version in this project is v7');
  }
  return environmentVar;
}
